/**
 * 앱 클라이언트 버전 기록.
 * 배포로 APP_VERSION 이 바뀌어도 로그인(토큰)은 유지한다.
 */
import { APP_VERSION } from '@/config/appVersion'

const CLIENT_VERSION_KEY = 'caion_app_client_version'

export function getStoredClientVersion(): string | null {
  try {
    return localStorage.getItem(CLIENT_VERSION_KEY)
  } catch {
    return null
  }
}

/**
 * 부팅 시 현재 버전만 기록. 세션은 건드리지 않는다.
 * @returns 항상 false (호출측 호환)
 */
export function syncAppClientVersion(): boolean {
  try {
    if (getStoredClientVersion() !== APP_VERSION) {
      localStorage.setItem(CLIENT_VERSION_KEY, APP_VERSION)
    }
  } catch {
    /* ignore */
  }
  return false
}

/** 로그인 성공 후 현재 버전 기록 */
export function markAppClientVersion() {
  try {
    localStorage.setItem(CLIENT_VERSION_KEY, APP_VERSION)
  } catch {
    /* ignore */
  }
}
